/* tslint:disable */
import {
  KanvasUser,
  Image
} from '../index';

declare var Object: any;
export interface ProfileInterface {
  "id": string;
  "DesignerSettings"?: any;
  "Theme"?: string;
  "Metadata"?: any;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  "kanvasUserId"?: string;
  kanvasUser?: KanvasUser;
  ProfileImage?: Image;
}

export class Profile implements ProfileInterface {
  "id": string;
  "DesignerSettings": any;
  "Theme": string;
  "Metadata": any;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  "kanvasUserId": string;
  kanvasUser: KanvasUser;
  ProfileImage: Image;
  constructor(data?: ProfileInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Profile`.
   */
  public static getModelName() {
    return "Profile";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Profile for dynamic purposes.
  **/
  public static factory(data: ProfileInterface): Profile{
    return new Profile(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Profile',
      plural: 'Profiles',
      path: 'Profiles',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "DesignerSettings": {
          name: 'DesignerSettings',
          type: 'any',
          default: <any>null
        },
        "Theme": {
          name: 'Theme',
          type: 'string',
          default: 'null'
        },
        "Metadata": {
          name: 'Metadata',
          type: 'any',
          default: <any>null
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "kanvasUserId": {
          name: 'kanvasUserId',
          type: 'string'
        },
      },
      relations: {
        kanvasUser: {
          name: 'kanvasUser',
          type: 'KanvasUser',
          model: 'KanvasUser',
          relationType: 'belongsTo',
                  keyFrom: 'kanvasUserId',
          keyTo: 'id'
        },
        ProfileImage: {
          name: 'ProfileImage',
          type: 'Image',
          model: 'Image',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'profileId'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Profile.ts